var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#E02020"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.628 28.557c-.435.444-1.012.664-1.588.664-.58 0-1.156-.22-1.6-.664l-5.429-5.43-5.469 5.457c-.434.437-1.007.668-1.586.668-.583 0-1.158-.231-1.602-.668-.886-.882-.886-2.311 0-3.19l5.456-5.457-5.429-5.43c-.872-.88-.872-2.303 0-3.188.888-.89 2.315-.89 3.2 0l5.43 5.429 5.404-5.412c.882-.878 2.309-.878 3.188 0 .88.881.88 2.315 0 3.2l-5.406 5.4 5.43 5.43c.888.876.888 2.308 0 3.19m5.52-22.704C30.36 2.08 25.34 0 20.001 0 14.651 0 9.632 2.08 5.854 5.852c-7.805 7.8-7.805 20.487 0 28.285C9.632 37.918 14.65 40 20.002 40c5.338 0 10.358-2.082 14.144-5.853C37.923 30.36 40 25.344 40 19.997c0-5.344-2.077-10.365-5.854-14.145",
    transform: "translate(-621 -357) translate(467 333) translate(37 24) translate(117)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error_icon.b86b1dd6e6a5b06f5d413c1ec22cba62.svg";
export { ForwardRef as ReactComponent };